import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import theme from "./constants/theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import NoInternetConnection from "./components/NoInternetConnection";
import ErrorBoundary from "./components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <NoInternetConnection>
        <App />
      </NoInternetConnection>
    </ThemeProvider>
  </ErrorBoundary>
  // </React.StrictMode>
);

// Unregister any existing service workers so you get fresh bundles
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    })
    .catch((err) => {
      console.error("Error unregistering service workers:", err);
    });
}
